export const catchaRefresh = () => {
    for (const img of document.querySelectorAll('img.captcha')) {
        const link = document.createElement('a')
        link.classList.add('captcha-refresh')
        link.style.cursor = 'pointer'
        link.title = gettext('Load another image.')
        link.appendChild(document.createTextNode('⟳'))
        img.after(link)
    }
    for (const link of document.querySelectorAll('a.captcha-refresh')) {
        link.addEventListener('click', (e) => {
            const img = e.target.previousElementSibling
            const captcha_hash = e.target.nextElementSibling

            fetch(window.location.origin + `/captcha/refresh/?t=${Date.now()}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`)
                    }
                    return response.json()
                })
                .then(data => {
                    captcha_hash.value = data.key
                    img.src = data.image_url
                })
                .catch(error => {
                    console.error('Fetch error:', error)
                })
        })
    }
}
